import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, IconName, DropdownItem } from '@optimus-web/core';
import { navigateInModal as navigateInModalAction } from '../../../app/actions/common';

interface Props {
    icon?: IconName;
    url?: string;
    buttonText?: React.ReactNode;
    navigateInModal?: $TSFixMeFunction;
}

class ConfirmationDialogMenuItem extends Component<Props> {
    handleClick = () => {
        (this.props as $TSFixMe).handleOpenDialog();
        (this.props as $TSFixMe).onAfterClick?.();
    };

    render() {
        const { icon, buttonText } = this.props;
        const componentProps = {
            leftDetail: icon ? <Icon value={icon} /> : undefined,
            label: buttonText,
        };

        return <DropdownItem {...componentProps} onClick={this.handleClick} />;
    }
}

export default connect(undefined, {
    navigateInModal: navigateInModalAction,
})(ConfirmationDialogMenuItem);
